export default [
  {
    value: 'fa-cogs',
    label: 'Auto Parts'
},{
  value: 'fa-child',
  label: 'Baby Kids & Toys'
},{
  value: 'fa-female',
  label: 'Clothing'
},{
  value: 'fa-laptop',
  label: 'Computers',
}, {
  value: 'fa-television',
  label: 'Electronics'
},{
  value: 'fa-gift',
  label: 'Fancy Items'
},{
  value: 'fa-bed',
  label: 'Furniture',
},{
  value: 'fa-bookmark',
  label: 'Handicrafts',
},{
  value: 'fa-medkit',
  label: 'Health & Beauty'
},{
  value: 'fa-glass',
  label: 'Household Supplies'
},{
  value: 'fa-link',
  label: 'Jewelry & Watches'          
},{
  value: 'fa-lightbulb-o',
  label: 'Lighting & Electrical'
},{
  value: 'fa-mobile',
  label: 'Mobiles & Tablets',
},{
  value: 'fa-music',
  label: 'Music',
},{
  value: 'fa-paw',
  label: 'Shoes & Footwear'
},{
  value: 'fa-futbol-o',
  label: 'Sports',
},{
  value: 'fa-shopping-basket',
  label: 'Supermarket',
},{
  value: 'fa-bath',
  label: 'Tiles & Bathware'
},{
  value: 'fa-wrench',
  label: 'Tools & Machines',
},
// {
//     value: 'fa-briefcase',
//     label: 'Bags'                       
// },
{
        value: 'fa-car',
        label: 'Vehicles' 
    },
  
// {
//     value: 'fa-gavel',
//     label: 'Outdoor' 
// },

//  {
//     value: 'fa-camera',
//     label: 'Cameras',
//   },
//   {
//     value: 'fa-home',
//     label: 'Home Decoration'
// },
// {
//     value: 'fa-window-maximize',
//     label: 'Window Treatments'
// },

// {
//     value: 'fa-book',
//     label: 'Books',
//  },
 
]


// WEBPACK FOOTER //
// ./src/data/caticons.js